import React from "react";
import "../styles/searchpage.css";
import "../styles/landingPage.css";
import "../styles/artworks.css";
import "../styles/common_elements.css";
import Button from "react-bulma-components/lib/components/button";
import Modal from "react-bulma-components/lib/components/modal";
// import converter from 'google-currency';
// const converter = require('google-currency');
import {inject, observer} from "mobx-react";
import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import {overFlowHidden, removeOverFlowHidden} from '../helpers/reusable'
import ReactGA from "react-ga";

const superagent = superagentPromise(_superagent, global.Promise);
// var fx = require("money");
// fx.base = "SGD";
// fx.rates = {

//     "SGD": 1,        // always include the base rate (1:1)
//     /* etc */
// }

const imagesPath = {
    unchecked: require('../assets/unchecked.png'),
    checked: require('../assets/checked.png')
}

var filterConfig = []


@inject('generalStore', 'searchPageArtworksStore', 'navigatorStore')
@observer
export default class filter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilters: false,
            filterKey: !!this.props.filterConfig ? "general" : "style",
            checkedFilter: false,
            // filterState: {},
            isClear: true
        }
    }
    handelFilterSearchClick() {
        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
        } else {
            this.setState({
                showFilters: true
            }, () => { overFlowHidden() })
        }
    }

    onCloseFilters() {
        this.setState({
            showFilters: false
        }, () => { removeOverFlowHidden() })
    }
    handelFilteTabClick(item) {
        this.setState({
            filterKey: item
        }, function () {
            // console.log("[handelFilteTabClick]", this.state)
        })
    }

    handelFilterChange(filterState, isClear) {
        this.props.handelFilterChangeMaster(filterState);
        this.setState({
            showFilters: false,
            isClear: isClear
        }, () => {
            removeOverFlowHidden();
            this.props.searchPageArtworksStore.resetPagination();
        })
    }

    render() {
    filterConfig =    [
            {
                filterKey: "style", display: "General",
                choices: [{ display: "Following Artists", key: "Following Artists" }, { display: "Artworks for sale", key: "Artworks for sale" }, { display: "Mature content", key: "Mature content" }, { display: "Artwork by kids", key: "Artwork by kids" }]
            },
            {
                filterKey: "medium", display: "Medium",
                choices: this.props.mediumChoices
            },
            {
                filterKey: "base", display: "Base",
                choices:
                   this.props.baseChoices
            },
            {
                filterKey: "pricing", display: "Pricing",
                initial: { currency: localStorage.getItem('preferred_currency') || (false) },
                extraProps: {
                    choices: [
                        { min_price: "0", max_price: "50" },
                        { min_price: "50", max_price: "100" },
                        { min_price: "100", max_price: "1000" },
                        { min_price: "1000", max_price: "10000" }
                    ]
                },
                isClear: (initial, componentState) => {
                    if (componentState.currency !== initial.currency) return false;
                    // if (componentState.range) return false;
                    if (componentState[`min_${componentState.currency}_price`]) return false;
                    if (componentState[`max_${componentState.currency}_price`]) return false;
                    // console.log("c1 isClear ", true)
                    return true;
                },
                customComponent: (props) => {
                    let { currentFilterState, currentFilterKey,
                        handleCurrencyChangeDiscard,
                        handleCustomRangeSelection,
                        wantsToChangeCurrency,
                        handleCurrencyChangeSelection,
                        handleCurrencySelection,
                        extraProps: { choices },
                        handleRangeSelection,
                        changePreferredCurrency,
                        currencySelected,
                        preferred_currency } = props;
                    // console.log("customComponent", props)
                    return <div style={{ position: "absolute", top: "4em", width: "72%" }}>
                        <div className="change-currency mt-25" style={{ display: (!wantsToChangeCurrency) ? "" : "none" }}>
                            <div className="col-md-6">
                                <label className="mb-0">Currency</label>
                                <h3 className="currency-text">{currentFilterState.currency}</h3>
                            </div>
                            <div className="col-md-6">
                                <button onClick={handleCurrencyChangeSelection} className="change-currency-btn pull-right">Change Currency</button>
                            </div>
                        </div>
        
                        <div className="change-currency-form" style={{ display: (wantsToChangeCurrency) ? "" : "none" }}>
        
                            <div className="col-md-12 form-currency">
                                <label>CHOOSE CURRENCY</label>
                                <select className="change-currency-select" value={currentFilterState.currency}
                                    onChange={(event) => {
                                        // console.log("Yolo ", event.target.value)
                                        handleCurrencySelection("pricing", event.target.value)
                                    }}   >
                                    <option style={{ display: "none" }}></option>
                                    {
                                        props.Currencies.map((el, idx) =>
                                            <option value={el.key}>{el.display}</option>
                                        )
                                    }
                                </select>
        
                                <p className="text-change-currency">This will change your preferred currency for your account on
                                    the entire platform.</p>
                            </div>
        
                            <div className="btn-change ml-15">
        
                                <button onClick={changePreferredCurrency} className="change-crr-btn">CHANGE CURRENCY</button>
                                <button onClick={handleCurrencyChangeDiscard} className="discard-crr-btn ml-15">DISCARD</button>
        
                            </div>
                        </div>
        
                        <div className="filter-price-checkboxes mt-15 ml-15">
                            {/* {currentFilterState.currency} {(props[`min_${currentFilterState.currency}_price`])} */}
                            {
                                choices.map((el, idx) => (
                                    < div className="filters-list-container report-block">
                                        <img
                                            onClick={() => props.handleRangeSelection(el.min_price, el.max_price)} alt="" className="filters-checkbox"
                                            src={
                                                ((currentFilterState[`min_${currentFilterState.currency}_price`] == el.min_price) && !currentFilterState.customRange) ?
                                                    imagesPath.checked : imagesPath.unchecked}
                                        />
                                        <p className="report-label-name">{el.min_price} - {el.max_price}</p>
                                    </div>
                                )
                                )
                            }
                            < div className="filters-list-container report-block">
                                <img
                                    onClick={() => props.handleRangeSelection(null, null, !currentFilterState.customRange)} alt="" className="filters-checkbox"
                                    src={
                                        (currentFilterState.customRange) ?
                                            imagesPath.checked : imagesPath.unchecked}
                                />
                                <p className="report-label-name">Custom</p>
                            </div>
                        </div>
                        <div style={{ width: "100%", display: (currencySelected) ? "" : "none", marginLeft: "10px" }} >
                            <input onChange={handleRangeSelection} value="custom" style={{ margin: "1% 0% 0% 1%" }} type="radio" name="currency" />Custom <br />
                        </div>
        
        
                        <div className="row ml-10 mt-25 mr-15" style={{ display: (currentFilterState.customRange) ? "flex" : "none" }}>
                            <div className="col-md-6 pl-0 pr-0">
                                <div className="form-group">
                                    <label htmlFor="from-price">FROM</label>
                                    <input className="bg-form"
                                        value={currentFilterState[`min_${currentFilterState.currency}_price`]}
                                        id="from-price" onChange={handleCustomRangeSelection} type="number"
                                        name={`min_${currentFilterState.currency}_price`} />
                                </div>
                            </div>
                            <div className="col-md-6 pr-0">
                                <div className="form-group">
                                    <label htmlFor="to-price">TO</label>
                                    <input id="to-price"
                                        className="bg-form"
                                        value={currentFilterState[`max_${currentFilterState.currency}_price`]}
                                        onChange={handleCustomRangeSelection} type="number"
                                        name={`max_${currentFilterState.currency}_price`} />
        
                                </div>
                            </div>
                        </div>
        
        
                    </div>
                }
            },
            {
                filterKey: "size", display: "Size", initial: { dimension: "CENTIMETERS", max_height: false, max_width: false, max_depth: false },
                isClear: (initial, componentState) => {
                    if (componentState.dimension !== initial.dimension) return false;
                    // if (Object.keys(componentState.size).length > 0) return false;
                    if (componentState.max_height) return false;
                    if (componentState.max_width) return false;
                    if (componentState.max_depth) return false;
                    // // console.log("c2 isClear ", true)
                    return true;
                },
                customComponent: (props) => {
                    let { handleCustomSizeSelection,
                        handleDimensionDropdown,
                        currentFilterState } = props;
                    // console.log("customComponent SIZE ", currentFilterState)
                    return <div style={{ position: "absolute", top: "4em", width: "100%" }}>
        
                        {/* < SelectCurrency style={{ backgroundColor: "#ffff", height: "unset" }} onChange={handleCurrencySelection} ></SelectCurrency> */}
                        <p className="filter-list-name" style={{ marginTop: "1%" }} >Select Unit</p>
                        {/* <select name="dimensionUnit" className="unit-dropdown" style={{ border: "0px", background: "#E7E7E7", height: "unset", flex: "1", width: "30%", marginTop: "1%", marginLeft: "16px" }} >
                            <option className="filter-list-name">INCHES</option>
                            <option className="filter-list-name">CM</option>
                            <option className="filter-list-name">Feet</option>
                        </select> */}
                        <div className="col-4 col-md-4 pl-0 pb-15">
                            <select className="dimension-units" onChange={(event) => {
                                // console.log("Yolo ", event.target.value)
                                handleDimensionDropdown("size", event.target.value)
                            }} value={currentFilterState.dimension || "CM"} style={{ border: "0px", background: "#E7E7E7", height: "unset", flex: "1", width: "30%", marginTop: "1%", marginLeft: "16px" }}>
                                <option style={{ display: "none" }}></option>
                                <option value="CENTIMETERS">CENTIMETERS</option>
                                <option value="METERS">METERS</option>
                                <option value="INCHES">INCHES</option>
                                <option value="FEET">FEET</option>
                            </select>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column" }} >
                            <p className="filter-list-name" style={{ marginTop: "1%" }} >Width</p>
                            <input style={{ border: "2px solid black", background: "#E7E7E7", height: "unset", flex: "1", width: "30%", marginTop: "1%", marginLeft: "16px" }}
                                value={currentFilterState.max_width} onChange={(event, t) => handleCustomSizeSelection(event, t)} type="number" name="max_width" />
                            <p className="filter-list-name" style={{ marginTop: "1%" }} >Height</p>
                            <input style={{ border: "0px", background: "#E7E7E7", height: "unset", flex: "1", width: "30%", marginTop: "1%", marginLeft: "16px" }}
                                value={currentFilterState.max_height} onChange={handleCustomSizeSelection} type="number" name="max_height" />
                            <p className="filter-list-name" style={{ marginTop: "1%" }}> Depth </p>
                            <input style={{ border: "0px", background: "#E7E7E7", height: "unset", flex: "1", width: "30%", marginTop: "1%", marginLeft: "16px" }}
                                value={currentFilterState.max_depth} onChange={handleCustomSizeSelection} type="number" name="max_depth" />
                        </div>
                    </div>
                }
            },
        ]
        return (
            <div className="col-12 col-md-12 col-lg-6 text-right pr-0">
                <button className="view-all-btn filter-btn"
                    style={{
                        backgroundColor: (!this.state.isClear) ? "#BEA57C" : "",
                        color: (!this.state.isClear) ? "white" : ""
                    }}
                    onClick={this.handelFilterSearchClick.bind(this)}>
                    <span>{(!this.state.isClear) ? "CHANGE FILTER" : "FILTER RESULTS"}</span>
                </button>
                <Modal show={this.state.showFilters} onClose={this.onCloseFilters.bind(this)}  >
                    <Modal.Content style={{ height: "auto" }}>
                        <div className="masterpieces-modal-header pt-20 pb-25 ml-25">
                            <p className="masterpieces-modal-heading">Filter Results
                                <img onClick={this.onCloseFilters.bind(this)} className="cross-icon-for-masterpieces-modal" src={require('../assets/cross_icon_for_close.png')}></img></p>
                        </div>
                        {/* <div className="masterpieces-modal-content" style={{ marginBottom: "unset", minHeight: "15em", maxHeight: "70em" }}> */}
                        <FilterTypes
                            handelFilteTabClick={this.handelFilteTabClick.bind(this)}
                            filterType={this.props.filterConfig || filterConfig} activeFilterKey={this.state.filterKey}
                            handelFilterChange={this.handelFilterChange.bind(this)}
                            initialOverallFilterState={this.props.currentOverallFilterState || false} />
                    </Modal.Content>
                </Modal>
            </div>
        )
    }

}

@inject('generalStore', 'userStore')
@observer
class FilterTypes extends React.Component {

    constructor(props) {
        super(props);
        if (props.initialOverallFilterState) {
            this.state = JSON.parse(JSON.stringify(props.initialOverallFilterState));
        } else {
            let filterMap = this.initializeFreshState(props);
            this.state = filterMap;
        }
        // console.log("[FILTER] rendered now , This state will look like", this.state);
        /* This state will look like  :
            
        
        */
    }

    componentDidMount() {
        ReactGA.pageview('/Filter screen');
        this.setState({
            pricing: {
                ...this.state.pricing,
                currency: localStorage.getItem('preferred_currency')
            }
        })
    }

    initializeFreshState(props) {
        props = props || this.props;
        let filterMap = {};
        props.filterType.forEach(
            (el) => {
                // let currFilter = {};
                filterMap[el.filterKey] = {};
                if (el.customComponent) {
                    if (!el.initial) throw "Please specify an initial value for this filter named " + el.filterKey
                    filterMap[el.filterKey] = el.initial;
                } else {
                    el.choices.forEach(choice => {
                        filterMap[el.filterKey][choice.key] = false;
                    })
                }
            }
        )
        // console.log(filterMap)
        return filterMap;
    }
    isFilterClear() {
        let isAllClear = true;
        let filterType = this.props.filterType;
        // console.log("isFilterClear", { filterType, stgate: this.state })
        filterType.forEach(
            (el) => {
                if (el.customComponent) {
                    if (!el.initial) throw "Please specify an initial value for this filter named " + el.filterKey
                    isAllClear = (isAllClear && el.isClear(el.initial, this.state[el.filterKey]))
                } else {
                    el.choices.forEach(choice => {
                        isAllClear = (isAllClear && !this.state[el.filterKey][choice.key]);
                        // console.log("c1 isAllClear ", isAllClear)
                    });
                }
            }
        )
        // console.log("returning isAllClear = ", isAllClear);
        return isAllClear;
    }
    handelFilterClick(choice, filterKey) {
        let toSet = !this.state[filterKey][choice];
        this.setState({
            [filterKey]: Object.assign(this.state[filterKey], { [choice]: toSet })
        }, () => {
        });
    }
    handelCustomFilterChange(filterKey) {
        return function (customFilterState) {
            this.setState({
                [filterKey]: Object.assign(this.state[filterKey], customFilterState)
            }, () => {
            });
        }
    }


    componentWillUnmount() {
        // console.log("{unmounting filter}")

    }

    handleCurrencySelection(filterKey, currencyAbbrevation) {
        // console.log(`Selected ${filterKey} =`, currencyAbbrevation)
        this.setState({
            [filterKey]: {
                ...this.state[filterKey],
                currency: currencyAbbrevation
            }
        }, function () {
            // console.log('Selected', this.state.pricing.currency)
            window.localStorage.setItem("preferred_currency", this.state.pricing.currency)
        })
    }
    handleCustomRangeSelection(e) {
        this.setState({
            pricing: {
                ...this.state.pricing,
                [e.target.name]: e.target.value,
            },

        })
    }
    handleRangeSelectionCurrency(min_price, max_price, custom) {
        if (custom) {
            this.setState({
                pricing: {
                    ...this.state.pricing,
                    customRange: custom,
                },
            })
        }
        else {
            this.setState({
                pricing: {
                    ...this.state.pricing,
                    customRange: false,
                    [`min_${this.state.pricing.currency}_price`]: min_price,
                    [`max_${this.state.pricing.currency}_price`]: max_price
                }
            })
        }
    }
    handelApplyFilterBtn() {
        ReactGA.pageview('/Apply filter action');
        if (!!this.state.size) window.localStorage.setItem("preferred_dimension", this.state.size.dimension)
        let isFilterClear = this.isFilterClear();
        this.props.handelFilterChange(this.state, isFilterClear)
    }
    handelClearBtn() {
        this.setState(
            this.initializeFreshState(), () => {
                this.props.handelFilterChange(this.state, true)
            }
        )
    }
    handleCustomSizeSelection(e, t) {
        // console.log("[handleCustomSizeSelection] ", e, e.target.name, '=', e.target.value)
        this.setState({
            size: {
                ...this.state.size, [e.target.name]: e.target.value,
            },

        })
    }

    handleCurrencyChangeSelection() {
        this.setState({
            wantsToChangeCurrency: true
        })
    }
    handleCurrencyChangeDiscard() {
        this.setState({
            wantsToChangeCurrency: false
        })
    }

    changePreferredCurrency() {
        this.props.userStore.requestToEditUserNoLoader(window.localStorage.getItem("profile_id"), null, { preferred_currency: this.state.pricing.currency })
            .then((response) => {
                // console.log(response)
                this.setState({
                    wantsToChangeCurrency: false
                })
            })
    }
    handleDimensionDropdown(filterKey, dimensionUnit) {
        // console.log(`Selected ${filterKey} =`, dimensionUnit)
        this.setState({
            [filterKey]: {
                ...this.state[filterKey],
                dimension: dimensionUnit
            }
        })
    }
    render() {
        return (
            <div>
                <div className="masterpieces-modal-content"
                    style={{ marginBottom: "unset", minHeight: "25em", maxHeight: "70em" }}>
                    {this.props.filterType.map(
                        (el, elIndex) => (
                            <div key={elIndex} className="filters-type-container">
                                <div onClick={() => this.props.handelFilteTabClick(el.filterKey)} className="filters-container fheight" key={elIndex} >
                                    <div className="filters-container" style={{
                                        backgroundColor: (el.filterKey == this.props.activeFilterKey) ? "#E7E7E7" : ""
                                    }} onClick={() => this.props.handelFilteTabClick(el.filterKey)}>
                                        <p className="filter-type-name" onClick={() => this.props.handelFilteTabClick(el.filterKey)}>{el.display}</p>
                                        <hr style={{ margin: "unset", borderColor: "#E7E7E7", backgroundColor: "#E7E7E7" }}></hr>
                                    </div>
                                </div>
                                <div className="filter-type-and-list-seprator" style={{ height: "13.7em" }} />
                                <div style={{
                                    display: "flex", flexDirection: "column", flex: 3, marginTop: 15, marginLeft: 15,
                                }}>
                                    {(el.filterKey == this.props.activeFilterKey) ?
                                        (el.customComponent
                                            ? el.customComponent({
                                                currentFilterState: this.state[el.filterKey],
                                                currencySelected: this.state.currencySelected,
                                                customRange: this.state.custom,
                                                extraProps: el.extraProps,
                                                handleCustomRangeSelection: this.handleCustomRangeSelection.bind(this),
                                                handleCFChange: this.handelCustomFilterChange(el.filterKey).bind(this),
                                                handleCurrencySelection: this.handleCurrencySelection.bind(this),
                                                handleRangeSelection: this.handleRangeSelectionCurrency.bind(this),
                                                handleCustomSizeSelection: this.handleCustomSizeSelection.bind(this),
                                                handleCurrencyChangeSelection: this.handleCurrencyChangeSelection.bind(this),
                                                handleCurrencyChangeDiscard: this.handleCurrencyChangeDiscard.bind(this),
                                                wantsToChangeCurrency: this.state.wantsToChangeCurrency,
                                                Currencies: this.props.generalStore.Currencies,
                                                min_price: this.state.pricing.min_price,
                                                changePreferredCurrency: this.changePreferredCurrency.bind(this),
                                                handleDimensionDropdown: this.handleDimensionDropdown.bind(this)
                                            })
                                            : <div style={{ position: "absolute", top: "4em", width: "100%" }}>
                                                {el.choices.map(choice => < div className="filters-list-container">
                                                    <img alt="" className="filters-checkbox"
                                                        src={this.state[el.filterKey][choice.key] ? imagesPath.checked : imagesPath.unchecked}
                                                        onClick={() => this.handelFilterClick(choice.key, el.filterKey)}></img>
                                                    <p className="filter-list-name">{choice.display}</p>
                                                    {/* <FilterTypeLists filterListNames={filterType} /> */}
                                                </div>)}
                                            </div>)
                                        : ''}
                                </div>
                            </div>
                        )
                    )
                    }
                </div>
                <div className="masterpieces-modal-footer pl-15 pr-15" style={{
                    display: "flex", justifyContent: "space-between"
                }}>
                    <Button className="view-all-btn filter-btn filter-clear" onClick={this.handelClearBtn.bind(this)}> CLEAR ALL</Button>
                    <Button className="masterpieces-tertiary-black-button btn-black height-48 filter-apply" onClick={this.handelApplyFilterBtn.bind(this)} >APPLY FILTERS</Button>
                </div>

            </div>

        )
    }
}




// WEBPACK FOOTER //
// ./src/helpers/filter.js